import { Component, OnInit } from '@angular/core';
import { PageMenuItem } from 'app/store/models/page.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  navigationLinks: PageMenuItem[] = [
    {
      label: 'About us',
      target: '/about_us',
    },
    {
      label: 'Announcement',
      target: '/announcements',
    },
    {
      label: 'Contact us',
      target: '/contact_us',
    },
    {
      label: 'Home',
      target: '/',
    },
    {
      label: 'Features',
      target: '/features',
    },
    {
      label: 'Pricing',
      target: '/pricing',
    },
    {
      label: 'Enterprise',
      target: '/enterprise',
    },
    {
      label: 'Partners',
      target: '/partners',
    },
  ];

  supportLinks: PageMenuItem[] = [
    {
      label: 'FAQ',
      target: '/faq',
    },
    {
      label: 'Login',
      target: '/login',
    },
    {
      label: 'Sign up',
      target: '/register',
    },
  ];

  constructor() {}

  ngOnInit() {}
}
